// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Nh6v","inputWrap":"Table_inputWrap__3E2xm","col":"Table_col__18jaO","bmiTooltip":"Table_bmiTooltip__2acdZ"};